<script>
import { user } from "./store.js"; 
import { onMount } from "svelte";
import { logout } from "./Services/firebase.js";
  
    const handleLogOut = () => {
        logout()
    };

    onMount(()=>{
     
    })
</script>

<style>
</style>

<div class="left">
    {#if $user.loggedIn}
        Welcome,
        <strong>{$user.displayName}</strong>
    {:else}Authentication required{/if}
</div>
<div class="right">
    {#if $user.loggedIn}
     <!--<a href="/profile">Your Profile</a>
        <a href="/settings">Settings</a>
        -->   
    {/if}
    {#if $user.loggedIn}
        <a href="/" class="bold" on:click={handleLogOut}>Log Out</a>
    {:else}
       
            <a href="#/login" class="bold">Login</a>
       
    {/if}
</div>
